import { render, staticRenderFns } from "./reviewFile.vue?vue&type=template&id=0555e704&scoped=true&"
import script from "./reviewFile.vue?vue&type=script&lang=js&"
export * from "./reviewFile.vue?vue&type=script&lang=js&"
import style0 from "./reviewFile.vue?vue&type=style&index=0&id=0555e704&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555e704",
  null
  
)

export default component.exports